import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Button, ButtonToolbar } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import renderSelectField from "../../../../../../shared/components/form/Select";
import renderToggleButtonField from "../../../../../../shared/components/form/ToggleButton";
import client from "../../../../../../shared/api-client";
import toQueryString from "../../../../../../shared/toQueryString";
import * as validate from "../../../../../../shared/validate";
import Modal from "../../../../../../shared/modal";
import * as users from "../../../../../../shared/service/users";

class ProfileSettings extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    user: [],
    show: false,
    success: "",
    errors: [],
    accountManagers: [],
    updated: [],
    authMethods: [
      {
        value: "ip",
        label: "Ip Based",
      },
      {
        value: "user",
        label: "User Based",
      },
    ],
    accessTypes: [
      {
        value: "whitelist",
        label: "Whitelist",
      },
      {
        value: "blacklist",
        label: "Full Access",
      },
    ],
    quotas: [
      {
        value: "500000",
        label: "500 GB",
      },
      {
        value: "1000000",
        label: "1 TB",
      },
      {
        value: "5000000",
        label: "5 TB",
      },
      {
        value: "10000000",
        label: "10 TB",
      },
      {
        value: "2147483647",
        label: "Unlimited",
      },
    ],
    concurrent_thread_limits: [
      {
        value: "10",
        label: "10",
      },
      {
        value: "50",
        label: "50",
      },
      {
        value: "100",
        label: "100",
      },
      {
        value: "500",
        label: "500",
      },
    ],
  };

  componentDidMount() {
    this.getProfile();
    this.getTeam();
  }

  getTeam = () => {
    client(`admin/team`).then((response) => {
      let accountManagers = [];

      response.forEach((accountManager) => {
        accountManagers.push({
          value: accountManager.aid.toString(),
          label: accountManager.name,
        });
      });

      this.setState({ accountManagers });
    });
  };

  getProfile = () => {
    users.getProfile(this.props.id).then((response) => {
      this.setState({ user: response, initial: response });
      this.props.initialize(response);
    });
  };

  formChangeHandler = (event) => {
    let name = event.target.name;
    let newValue = event.target.value;

    let updated = this.state.updated;
    updated[name] = newValue;

    this.setState(updated);
  };

  changeForm = (event, newValue, previousValue, name) => {
    let updated = this.state.updated;

    if (typeof newValue === "object") {
      updated[name] = newValue.value;
    } else {
      updated[name] = newValue;
    }
    this.setState(updated);
  };

  save = () => {
    let params = toQueryString({
      uid: this.props.id,
    });

    let updated = this.state.updated;

    if (this.state.updated.suspend === this.state.user.suspend) {
      delete updated["suspend"];
    }

    let errors = [];

    if (this.state.updated.first_name !== undefined) {
      if (
        !validate.required(this.state.updated.first_name) ||
        !validate.name(this.state.updated.first_name)
      ) {
        errors.push("Please enter a valid first name.");
      }
    }

    if (this.state.updated.last_name !== undefined) {
      if (
        !validate.required(this.state.updated.last_name) ||
        !validate.name(this.state.updated.last_name)
      ) {
        errors.push("Please enter a valid last name.");
      }
    }

    if (this.state.updated.email !== undefined) {
      if (
        !validate.required(this.state.updated.email) ||
        !validate.email(this.state.updated.email)
      ) {
        errors.push("Please enter a valid email address.");
      }
    }

    if (this.state.updated.phone !== undefined) {
      if (
        !validate.required(this.state.updated.phone) ||
        !validate.phone(this.state.updated.phone)
      ) {
        errors.push("Please enter a valid phone number.");
      }
    }

    if (errors.length > 0) {
      this.setState({ show: true, errors: errors, success: "" });
      return false;
    } else if (Object.keys(updated).length > 0) {
      client(`user_profile.php?${params}`, {
        method: "PUT",
        body: { ...this.state.updated },
      }).then(
        (response) => {
          this.setState({
            show: true,
            success: `User ${this.props.tab} has been updated successfully.`,
          });
        },
        (error) => {
          this.setState({ show: true, errors: error._user_message });
        }
      );
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <form
        autoComplete="off"
        className="form form--horizontal"
        onSubmit={handleSubmit}
      >
        {this.props.tab === "Profile" ? (
          <React.Fragment>
            <div className="form__form-group">
              <span className="form__form-group-label">First name</span>
              <div className="form__form-group-field">
                <Field
                  name="first_name"
                  component="input"
                  type="text"
                  placeholder="First Name"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Last name</span>
              <div className="form__form-group-field">
                <Field
                  name="last_name"
                  component="input"
                  type="text"
                  placeholder="Last name"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Email</span>
              <div className="form__form-group-field">
                <Field
                  name="email"
                  component="input"
                  type="text"
                  placeholder="Email address"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Phone</span>
              <div className="form__form-group-field">
                <Field
                  name="phone"
                  component="input"
                  type="text"
                  placeholder="Phone"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>

            <div className="form__form-group">
              <span className="form__form-group-label">Type</span>
              <div className="form__form-group-field">
                <Field
                  name="user_type"
                  component={renderSelectField}
                  options={this.props.userTypes}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="card__title">
              <h5 className="bold-text">Company</h5>
              <hr />
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Company</span>
              <div className="form__form-group-field">
                <Field
                  name="company_name"
                  component="input"
                  type="text"
                  placeholder="Company"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Phone</span>
              <div className="form__form-group-field">
                <Field
                  name="company_number"
                  component="input"
                  type="text"
                  placeholder="Company Phone"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Industry</span>
              <div className="form__form-group-field">
                <Field
                  name="industry"
                  component={renderSelectField}
                  placeholder="Industry"
                  options={this.props.industry}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Role</span>
              <div className="form__form-group-field">
                <Field
                  name="company_role"
                  component={renderSelectField}
                  placeholder="Company role"
                  options={this.props.role}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Business Size</span>
              <div className="form__form-group-field">
                <Field
                  name="business_size"
                  component={renderSelectField}
                  placeholder="Business Size"
                  options={this.props.businessSizes}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="card__title">
              <h5 className="bold-text">Address</h5>
              <hr />
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Address</span>
              <div className="form__form-group-field">
                <Field
                  name="address"
                  component="input"
                  type="text"
                  placeholder="Address"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">City</span>
              <div className="form__form-group-field">
                <Field
                  name="city"
                  component="input"
                  type="text"
                  placeholder="City"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Zip</span>
              <div className="form__form-group-field">
                <Field
                  name="zip"
                  component="input"
                  type="text"
                  placeholder="Zip"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Company Country</span>
              <div className="form__form-group-field">
                <Field
                  name="company_country"
                  component="input"
                  type="text"
                  placeholder="Company"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                <b>Suspend Account</b>
              </span>
              <div className="form__form-group-field">
                <Field
                  name="suspend"
                  component={renderToggleButtonField}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
              <p className="wizard__description">
                This will deactivate and suspend the user account. They will
                never be able to use it unless permission is granted.
              </p>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        )}
        {this.props.tab === "Access Settings" ? (
          <React.Fragment>
            <div className="form__form-group">
              <span className="form__form-group-label">Auth Method</span>
              <div className="form__form-group-field">
                <Field
                  name="auth_method"
                  component={renderSelectField}
                  options={this.state.authMethods}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Access Type</span>
              <div className="form__form-group-field">
                <Field
                  name="access_type"
                  component={renderSelectField}
                  options={this.state.accessTypes}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Monthly Quota</span>
              <div className="form__form-group-field">
                <Field
                  name="quota"
                  component={renderSelectField}
                  options={this.state.quotas}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                Concurrent Thread Limit
              </span>
              <div className="form__form-group-field">
                <Field
                  name="concurrent_thread_limit"
                  component={renderSelectField}
                  options={this.state.concurrent_thread_limits}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        )}

        {this.props.tab === "Notes" && (
          <React.Fragment>
            <div className="form__form-group">
              <span className="form__form-group-label">Notes</span>
              <div className="form__form-group-field">
                <Field
                  name="comments"
                  component="textarea"
                  type="textarea"
                  placeholder="Notes"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
          </React.Fragment>
        )}

        {this.props.tab === "Settings" ? (
          <React.Fragment>
            <div className="form__form-group">
              <span className="form__form-group-label">Account Manager</span>
              <div className="form__form-group-field">
                <Field
                  name="account_manager"
                  component={renderSelectField}
                  options={this.state.accountManagers}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Onboarding Status</span>
              <div className="form__form-group-field">
                <Field
                  name="onboarding_status"
                  component={renderSelectField}
                  options={this.props.onBoardingStatus}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Source</span>
              <div className="form__form-group-field">
                <Field
                  name="source"
                  component={renderSelectField}
                  options={this.props.sources}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Lead Score</span>
              <div className="form__form-group-field">
                <Field
                  name="lead"
                  component={renderSelectField}
                  options={this.props.leadScores}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>

            <div className="form__form-group">
              <span className="form__form-group-label">Lead Stage</span>
              <div className="form__form-group-field">
                <Field
                  name="lead_stage"
                  component={renderSelectField}
                  options={this.props.leadStages}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">UTM</span>
              <div className="form__form-group-field">
                <Field
                  name="utm"
                  component={renderSelectField}
                  options={this.props.utmSources}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Product Use Case</span>
              <div className="form__form-group-field">
                <Field
                  name="product_use_case"
                  component={renderSelectField}
                  options={this.props.productUseCases}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Domains Used In</span>
              <div className="form__form-group-field">
                <Field
                  name="domains_used_in"
                  component={renderSelectField}
                  options={this.props.domainsUsedIn}
                  onChange={(event, newValue, previousValue, name) =>
                    this.changeForm(event, newValue, previousValue, name)
                  }
                />
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        )}
        <fieldset>
          {/* <div className="form__form-group">
            <span className="form__form-group-label">
              <b>Unverify Account</b>
            </span>
            <div className="form__form-group-field">
              <Field
                name="verified"
                component={renderToggleButtonField}
                onChange={(event, newValue, previousValue, name) =>
                  this.changeForm(event, newValue, previousValue, name)
                }
              />
            </div>
            <p className="wizard__description">
              Unsets the email and phone verification to unverified.
            </p>
          </div> */}
          <ButtonToolbar className="form__button-toolbar-bkp">
            <Button color="primary" type="button" onClick={this.save}>
              Update {this.props.tab}
            </Button>
            {/* <Button type="button" onClick={reset}>
          Cancel
        </Button> */}
          </ButtonToolbar>
          <Modal
            onClose={() => this.setState({ show: false })}
            show={this.state.show}
            errors={this.state.errors}
            success={this.state.success}
          ></Modal>
        </fieldset>
      </form>
    );
  }
}

export default reduxForm({
  form: "profile_settings_form", // a unique identifier for this form
})(ProfileSettings);
